import gql from 'graphql-tag'

export const QUERY = gql`
  query course_lessons_index($page: Int!, $perPage: Int!) {
    courseLessons(page: $page, perPage: $perPage) {
      nodes {
        id
        title
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }
`
